// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class WorkspaceManagerHelper {
    constructor() {
        this._showLogs = false;
    }
    setShowLogs(showLogs) {
        this._showLogs = showLogs;
    }
    isShowLogs() {
        return this._showLogs;
    }
    saveWorkspaceImmediately(aim) {
        if (aim === SaveWorkspaceAim.Local) {
            if (!this.saveWorkspaceLocal) {
                console.log('saveWorkspaceLocal not initialized');
                return;
            }
            console.log('Run saveWorkspaceLocal');
            void this.saveWorkspaceLocal();
        }
        else if (aim === SaveWorkspaceAim.Server) {
            if (!this.saveWorkspaceRemote) {
                console.log('saveWorkspaceRemote not initialized');
                return;
            }
            console.log('Run saveWorkspaceRemote');
            void this.saveWorkspaceRemote();
        }
    }
    __init(saveWorkspaceLocal, saveWorkspaceRemote) {
        this.saveWorkspaceLocal = saveWorkspaceLocal;
        this.saveWorkspaceRemote = saveWorkspaceRemote;
    }
}
export var SaveWorkspaceAim;
(function (SaveWorkspaceAim) {
    SaveWorkspaceAim["Local"] = "local";
    SaveWorkspaceAim["Server"] = "server";
})(SaveWorkspaceAim || (SaveWorkspaceAim = {}));
export const wmh = new WorkspaceManagerHelper();
